import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import api from "@/lib/axios"
import SkeletonTable from "@/components/SkeletonTable"

const getListGrupPrestasi = async () => {
  const response = await api.get("/master/grup-prestasi/index", {
    withCredentials: true,
  })
  return response.data?.data
}

export default function MasterGrupPrestasiPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listGrupPrestasi"],
    queryFn: getListGrupPrestasi,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
